<template>
  <div>
    <van-cell>
      <template #title>
        <div class="graphic-left">{{ cardInfo.name }}</div>
      </template>
      <template #icon>
        <van-image width="50" height="50" :src="cardInfo.headerImg" />
      </template>
      <template #label>
        <div class="graphic-left">{{dataList.artcSummary}}</div>
        <div class="imgList-sty graphic-left">
          <div
            v-for="(item,index) in imgList"
            :key="index"
            :class="imgList.length>1 ? 'img-size img-size1':'img-size2 img-size'"
          >
            <van-image @click="seeImg(imgList,$event)" v-if="item" width="100%" height="100%" :src="item" />
          </div>
        </div>
      </template>
    </van-cell>
  </div>
</template>

<script>
import URL from "@/api/api";
import wx from "weixin-js-sdk";
import { Toast, Dialog, ActionSheet } from "vant";
import { ImagePreview } from "vant"; // 引入Vant图片预览组件
export default {
  data() {
    return {
      name: '张三',
      value: '',
      imgList:[],

      dataList:{},
      cardInfo: "",
      changeMe: true,
      isGsc: false,
      articleId: "",
      title: "",
      refname: "",
      reflink: "",
      viewcount: 0,
      fwdcount: 0,
      artctype: "",
      publishDate: "",
      content: "",
      baseUrl: "",
      shareLink: "",
      shareImg: "",
      openId: sessionStorage.getItem("openId"),
      firstTransferPerson: "",
      lastTransferPerson: "",
      customerName: "",
      customerPhoneNumber: "",
      showCode: false,
      showShareTip: false,
      headerImg: "",
      unionid: "",
      lblName: "",
      showKfInfo: false,
      artcsummary: "",
      showLongBtn: "y",
      showCard: false,
      isReg: false,
      openStatement: false,
      showSheet: false,
      articleLink: false,
      url: "",
      actions: [
        { id: 0, name: "举报非此品牌内容", className: "one" },
        { id: 1, name: "举报文章内容质量差", className: "one" },
        { id: 2, name: "涉及欺诈、色情、版权问题", className: "one" },
      ],
      isAdmin: false,
    }
  },
  computed: {
    transid: () => {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
  },
  created() {
    var that = this;
    that.$nextTick(function () {
      that.unionid = sessionStorage.getItem("unionid");
    });
  },
  mounted() {
    //  this.getDetails();//去掉
    if (location.hostname == 'dtfcloud.com') {
      this.url = 'https://dtfcloud.com/'
    } else {
      this.url = 'https://jzt.dtfcloud.com/'
    }
    var that = this;
    setTimeout(function () {
      that.checkPower();
    }, 500);

    this.unionid = sessionStorage.getItem("unionid");

    if (!this.getUrlParams("firstTransferPerson")) {
      this.changeMe = false;
    } else {
      if (this.unionid == this.getUrlParams("firstTransferPerson")) {
        this.changeMe = false;
      }
    }
    that.showLongBtn = this.$route.query.showLongBtn;
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.cancel, false);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.cancel, false);
  },
  methods: {
    seeImg(ele, e){
      let images = ele;
      // let index = images.findIndex(item => item == e.target.src)
      ImagePreview({
        images: images, //需要预览的图片 URL 数组
        showIndex: true, //是否显示页码
        loop: true, //是否开启循环播放
        // startPosition: 1, //图片预览起始位置索引
        showIndicators: true, //轮播指示器
        closeable: true,
      })
    },
    checkPower() {
      let that = this;
      this.$fetchPost(URL.checkAuthority.url,{
        unionid: this.getUrlParams("firstTransferPerson"),
      }).then(res=>{
        if (res) {
          if (res.data) {
            this.isAdmin = true;
          }
          this.articleId =
            this.$route.query.articleId || sessionStorage.getItem("articleId");
          this.firstTransferPerson = this.getUrlParams("firstTransferPerson")
            ? this.isAdmin
              ? sessionStorage.getItem("unionid")
              : this.getUrlParams("firstTransferPerson")
            : sessionStorage.getItem("unionid");
          this.lastTransferPerson = this.getUrlParams("lastTransferPerson");
          this.first_openid = this.getUrlParams("first_openid")
            ? this.isAdmin
              ? sessionStorage.getItem("openId")
              : this.getUrlParams("first_openid")
            : sessionStorage.getItem("openId");
          this.getCard(this.firstTransferPerson);
          if (location.hostname === "zf.dtfcloud.com") {
            that.baseUrl = "https://zf.dtfcloud.com/";
            that.appId = "wxae0168c583647722";
          } else {
            that.baseUrl = "http://jzt.dtfcloud.com/";
            that.appId = "wxae0168c583647722";
          }
          let url =
            that.baseUrl +
            "article/index.html#/graphicDetails?articleId=" +
            that.articleId +
            "&firstTransferPerson=" +
            that.firstTransferPerson +
            "&lastTransferPerson=" +
            sessionStorage.getItem("unionid") +
            "&type=ART&first_openid=" +
            sessionStorage.getItem("openId");
          that.shareLink =
            that.baseUrl +
            "article/static/html/redirect.html?app3Redirect=" +
            encodeURIComponent(url);
          setTimeout(function () {
            sessionStorage.setItem("articleId", that.articleId);
            that.openId =
              sessionStorage.getItem("openId") || that.$route.query.openId;
            that.getDetails();
          }, 500);
        }
      })
    },
    getUrlParams: function (paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }
    },
    showShare() {
      this.showShareTip = true;
      this.copyText();
    },
    complaint(e) {
      this.$fetchPost(URL.insertComplaints.url,{
        artcid: this.articleId,
        artctype: this.artctype,
        userid: this.unionid,
        complain: e.name,
      }).then(res=>{
      })
      Toast("举报成功");
    },
    openLink() {
      window.location.href = this.reflink;
    },
    openState() {
      this.openStatement = !this.openStatement;
      this.articleLink = false;
    },
    openSub() {
      this.showKfInfo = true;
    },
    // 主要获取服务领域
    getServLabelList(id) {
      this.$fetchGet(URL.getCard.url,{
        id,
        type: "1",
      }).then(res=>{
        if (res.responseResult.responseCode === "0000") {
          if (res.agentCardReq) {
            const lbl = res.agentCardReq.servLabelList.map((item) => {
              return item.lblName;
            });
            this.lblName = lbl.toString();
          }
        }
      })
    },
    cancel: function () {
      if (
        this.$route.query.canBack != "y" &&
        this.$route.name == "articleDetails"
      ) {
       window.WeixinJSBridge.call("closeWindow");
      } else {
        this.$router.go(-1);
      }
    },

    getDetails() {
      let that = this;
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true,
      });
      that.$fetchGet(URL.graphicDetails.url,{
        aid: that.articleId
      }).then(res=>{
         Toast.clear();
        if(res.data.code=='20000'){
          let newData=res.data.data.list
          newData.map((x,i)=>{
            if (x != null && x != '' && x != undefined && x != 'undefined') {
              that.imgList.push(x)
            }
          })
          that.dataList=res.data.data.tAisArticleWxPicwrd
          that.title = res.data.data.tAisArticleWxPicwrd.title;
          that.refname = res.data.data.tAisArticleWxPicwrd.refname;
          that.viewcount = res.data.data.tAisArticleWxPicwrd.viewcount;
          that.fwdcount = res.data.data.tAisArticleWxPicwrd.fwdcount;
          that.publishDate = res.data.data.tAisArticleWxPicwrd.pubdate;
          that.content = res.data.data.tAisArticleWxPicwrd.content;
          // this.share(this.title,'',this.shareLink,this.shareImg)
          that.title = res.data.data.tAisArticleWxPicwrd.title;
          that.refname = res.data.data.tAisArticleWxPicwrd.refname;
          that.reflink = res.data.data.tAisArticleWxPicwrd.reflink;
          that.publishDate = res.data.data.tAisArticleWxPicwrd.pubdate;
          // that.content = res.aisArticle.content;
          // that.shareImg = res.data.data.tAisArticleWxPicwrd.coverlink;
          that.shareImg = res.data.data.list[0];
          that.artcsummary = res.data.data.tAisArticleWxPicwrd.friendsummary;
          that.artctype = res.data.data.tAisArticleWxPicwrd.artctype;
          that.share(
            that.title,
            that.artcsummary,
            that.shareLink,
            // res.aisArticle.coverlink
            that.shareImg
          );
          setTimeout(() => {
            var activeData = {
              transId: that.transid,
              timeFlag: that.getTimeStamp(2),
              actionType: "visit",
              action: "ACT6",
              userId: sessionStorage.getItem("unionid")
                ? sessionStorage.getItem("unionid")
                : sessionStorage.getItem("openId"),
              unionid: sessionStorage.getItem("unionid"),
              funcId: that.getUrlParams("articleId"),
              url: window.location.href,
              fromUrl: document.referrer,
              productId: that.getUrlParams("type"),
              nikename: sessionStorage.getItem("nickname"),
              headImgUrl: sessionStorage.getItem("headImgUrl"),
              buttonId: sessionStorage.getItem("firstTransferPerson"),
              accessType: "V1",
              source: "wx",
              customerId: sessionStorage.getItem("unionid"),
              // customerId:that.unionid,
              funcName: res.data.data.tAisArticleWxPicwrd.title,
              viewDuration: "5",
            };

            that.submitUserActive(activeData);
            that.submitVisitedTimes(activeData);
            //代码
          }, 3000);

        }
      })
    },
    //获取微信头像
    getArticleUserInfo(obj) {
      var that = this;
      that.$fetchPost(URL.queryMyMessage.url,{
        phoneNumber: obj.tel, openId: obj.openId
      }).then(res=>{
          if (res) {
            that.headerImg = res.data.data.result.headImgUrl;
          } else {
            Toast("请求失败");
          }
      })
    },
    getFormatDate() {
      let publishDate = "";
      const date = new Date(Date.parse(new Date()));
      const Y = date.getFullYear() + "-";
      const M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      const D =
        date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate();
      publishDate = Y + M + D;
      return publishDate;
    },
    getCard(id) {
      let that = this;
      //that.getServLabelList(that.first_openid);c
       that.$fetchGet(URL.getCardByUnionid.url, {
         unionid: that.firstTransferPerson ? that.firstTransferPerson : id,
       }).then(res => {
          if (res.data.code == "20000") {
            if (res.data.data != null) {
              that.cardInfo = res.data.data;
              that.showCard = true;
            } else {
              that.cardInfo = {
                name: "i致富",
                tel: "",
                headerImg: require("./img/bin.png"),
              };
            }
          }

      })
    },
    goToCard() {

      window.location.href =
        this.url + "loan-pro/#/cDetails?flg=1&isInfo=1&id=" + this.cardInfo.id;


    },
    chekCard() {
      if (
        this.firstTransferPerson &&
        this.firstTransferPerson != sessionStorage.getItem("unionid")
      ) {
        window.location.href =
          this.baseUrl +
          "centre/index.html#/myCard?openId=" +
          this.firstTransferPerson +
          "&first_openid=" +
          sessionStorage.getItem("openId");
      }
    },

    checkAuth() {
      var that = this;
      // that
      //   .$post("authentication", {
      //     openid: that.openId,
      //     unionid: sessionStorage.getItem("unionid"),
      //     id: "3"
      //   })
      //   .then(res => {
      //     if (res.data == 0) {
      that.firstTransferPerson = sessionStorage.getItem("unionid");
      that.getCard(); //拥有权限
      that.changeMe = false;
      let url =
        that.baseUrl +
        "article/index.html#/graphicDetails?articleId=" +
        that.articleId +
        "&firstTransferPerson=" +
        that.firstTransferPerson +
        "&lastTransferPerson=" +
        sessionStorage.getItem("unionid");
      that.shareLink =
        that.baseUrl +
        "article/static/html/redirect.html?app3Redirect=" +
        encodeURIComponent(url);
      that.share(that.title, that.artcsummary, that.shareLink, that.shareImg);
      // } else if (res.data == 1) {
      //   let cardUrl = "";
      //   Toast("查询到您未设置名片，稍后将跳转到名片设置页");
      //   if (location.hostname === "ufc.dtfcloud.com") {
      //     cardUrl =
      //       "https://ufc.dtfcloud.com/centre/index.html#/myCardEdit?openId=" +
      //       sessionStorage.getItem("openId") +
      //       "&unionid=" +
      //       sessionStorage.getItem("unionid") +
      //       "&isReg=no";
      //   } else {
      //     cardUrl =
      //       "http://www.bjnfbk.com/centre/index.html#/myCardEdit?openId=" +
      //       sessionStorage.getItem("openId") +
      //       "&unionid=" +
      //       sessionStorage.getItem("unionid") +
      //       "&isReg=no";
      //   }
      //   setTimeout(function() {
      //     window.location.href = cardUrl; // that.showCode=true;
      //   }, 1500);
      // }
      // })
      // .catch(err => {
      // });
    },
    //验证是否是注册用户
    checkUser(e) {
      e.stopPropagation();
      this.$fetchGet(URL.checkUser.url,{
        openid: sessionStorage.getItem("openId"),
      }).then(res=>{
         if (
          res.code == "20000" &&
          res.data.authFlag == "1" &&
          res.data.buyFlag == "1"
        ) {
          //已注册
          this.isReg = true;
          this.checkAuth();
        } else {
          //用户未注册
          let registerUrl = "";
          this.isReg = false;
          Toast("你还未注册i致富，即将跳转到注册页面");

          if (location.hostname === "zf.dtfcloud.com") {
            registerUrl = "https://zf.dtfcloud.com/";
          } else {
            registerUrl = "https://jzt.dtfcloud.com/test-zfkj/";
          }
          setTimeout(function () {
            window.location.href = registerUrl;
          }, 1500);
        }
        if (res.ret == "200008") {
          // alert("您还未注册");
          this.isReg = false;
        }
      })
    },
    //复制文本
    copyText() {
      if (this.artcsummary) {
        this.$copyText(this.artcsummary)
          .then((res) => {
            Toast("朋友圈配文已复制");
          })
          .catch((err) => { });
      }
    },
    share(title, desc, shareLink, shareImg) {
      let that = this;
      let url = location.href.split("#")[0];
      that.$fetchGet(URL.articleShare.url,{ url: url}).then(res=>{
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.noncestr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: [
            "onMenuShareAppMessage",
            "onMenuShareTimeline",
            "hideMenuItems",
          ], // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImg, // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            success: function () {
              // 用户确认分享后执行的回调函数
              that.$fetchPost(URL.articleShareSuccess.url,{
                temp: 0 || '0',
                activitieId: that.articleId,
                customerName: that.cardInfo.name,
                customerPhoneNumber: that.cardInfo.tel,
                firstTransferPerson: that.firstTransferPerson,
                lastTransferPerson: sessionStorage.getItem("unionid")
                  ? sessionStorage.getItem("unionid")
                  : sessionStorage.getItem("openId"),
                activityType: "ART",
                agtid: sessionStorage.getItem("unionid")
                  ? sessionStorage.getItem("unionid")
                  : sessionStorage.getItem("openId"),
                unionid: sessionStorage.getItem("unionid"),
                nikename: sessionStorage.getItem("nickname"),
                headImgUrl: sessionStorage.getItem("headImgUrl"),
                wechatNumber:
                  sessionStorage.getItem("unionid") != that.firstTransferPerson
                    ? that.getUrlParams("lastTransferPerson")
                    : "", //上次转发人
                source: "wx",
                customerId: sessionStorage.getItem("unionid"),
                funcName: title,
              });
            },
            cancel: function () { },
          });
          wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImg, // 分享图标
            success: function () {
              // alert(_ok)
              // 用户确认分享后执行的回调函数
              that.$fetchPost(URL.articleShareSuccess.url,{
                temp: 0 || '0',
                activitieId: that.articleId,
                customerName: that.cardInfo.name,
                customerPhoneNumber: that.cardInfo.tel,
                firstTransferPerson: that.firstTransferPerson,
                lastTransferPerson: sessionStorage.getItem("unionid")
                  ? sessionStorage.getItem("unionid")
                  : sessionStorage.getItem("openId"),
                activityType: "ART",
                agtid: sessionStorage.getItem("unionid")
                  ? sessionStorage.getItem("unionid")
                  : sessionStorage.getItem("openId"),
                unionid: sessionStorage.getItem("unionid"),
                nikename: sessionStorage.getItem("nickname"),
                headImgUrl: sessionStorage.getItem("headImgUrl"),
                wechatNumber:
                  sessionStorage.getItem("unionid") != that.firstTransferPerson
                    ? that.getUrlParams("lastTransferPerson")
                    : "", //上次转发人
                source: "wx",
                customerId: sessionStorage.getItem("unionid"),
                funcName: title,
              });
            },
          });
        });
      });
    },
    getTimeStamp: function (format) {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      //精确到天
      if (format == 1) {
        time = year + "-" + month + "-" + date;
      }
      //精确到分
      else if (format == 2) {
        time =
          year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      }
      return time;
    },
    //统计时长
    submitVisitedTimes(data) {
      let that = this;
      //   let data = {
      //     transId: that.transid,
      //     viewDuration: 5
      //   };
      that.$fetchPost(URL.subViewduration.url,data).then(res=>{
      })
    },
    //
    submitUserActive: function (obj) {
      let that = this;
      that.$fetchPost(URL.userActive.url,obj).then(res=>{
      })
      // alert('提交成功')
    },
    // 生成唯一ID
    getTransId: function () {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
  },
}
</script>

<style lang="less" scoped>
.graphic-left {
  padding-left: 10px;
}
.imgList-sty {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  .img-size {
    margin: 0 1vw;
  }
  .img-size2 {
    width: 100%;
  }
  .img-size1 {
    width: 30%;
  }
}
//
</style>
